import { useEffect, useRef, useState } from "react";
import ShrinkText from "../../components/common/ShrinkText";
import { IEvent } from "../../screens/header/home-page/HomePageController";
import { fetchEvents } from "./EventsController";
import { PAGINATION_PER_PAGE_ROWS } from "../../utils/AppConstants";
import usePaginationHook from "../../hooks/UsePaginationHook";
import { useNavigate } from "react-router-dom";
import { publicRoute } from "../../routes/RoutePublic";
import { TScrollEvent } from "../../data/AppType";
import { IPagination } from "../../data/AppInterface";
import UseTranslationHook from "../../hooks/UseTranslationHook";
import VerticalBuffer from "../../components/common/VerticalBuffer";
import ICImage from "../../core-component/ICImage";
import { searchIcon } from "../../assets/icons/SvgIconList";
import EventsViewSkeleton from "./evets-skeleton/EventsViewSkeleton";
import EventCard from "./EventCard";
import PublicHeader from "../public-header/PublicHeader";
import Loader from "../../components/common/Loader";
import PaginationFooter from "../../components/page-layouts/PaginationFooter";
import { PUBLIC_HEADER_TABS, PUBLIC_TABS } from "../../utils/AppEnumerations";
import CopyrightFooter from "../../components/common/CopyrightFooter";

const EventsView = () => {
  const [buffer, setBuffer] = useState(true);
  const [loading, setLoading] = useState(true);
  const [publicLoader, setPublicLoader] = useState(true);
  const { t } = UseTranslationHook();
  const [eventsList, setEventList] = useState<IEvent[]>([]);
  const listInnerRef = useRef<HTMLDivElement>(null);
  const [enterpriseSearch, setEnterpriseSearch] = useState("");
  const navigate = useNavigate();

  const { pagination, setPagination } = usePaginationHook({
    pagination: {
      per_page_rows: Number(PAGINATION_PER_PAGE_ROWS.Six),
      current_page: 1,
      sort_by: "id",
      order_by: "DESC",
    },
  });

  const fetchEventList = async (
    payloadPagination: IPagination,
    events: IEvent[],
    append: boolean
  ) => {
    await fetchEvents(
      setEventList,
      setPagination,
      payloadPagination,
      events,
      setLoading,
      setBuffer,
      {
        enterpriseSearch,
      },
      append
    );
  };

  useEffect(() => {
    fetchEventList({ ...pagination, current_page: 1 }, eventsList, false);
  }, [enterpriseSearch]);
  useEffect(() => {
    document.title = PUBLIC_TABS.Events;
    setTimeout(async () => {
      setPublicLoader(false)
    }, 2000);
  })
  const [active, setActive] = useState<boolean>(false)

  return (
    <div className="min-h-screen bg-skin-home-bg">

      {loading || publicLoader ? (
        <div className="h-screen flex items-center flex-col bg-black">
          <Loader />
        </div>) :
        (<>
          <div className='h-24 relative'> <PublicHeader activeTab={PUBLIC_HEADER_TABS.Events} /></div>
          <div className=" bg-skin-home-bg flex justify-center">
            <div className="col-span-12 md:col-span-12 lg:col-span-12 xl:col-span-12 h-full xl:w-3/4 md:h-auto">
              <div className="w-full mt-3 p-2">
                <div
                  className={`mr-5 mb-1 flex w-full items-center p-3 web-shadow`}
                >
                  <div className="w-6 h-6">{searchIcon}</div>
                  <div
                    className="w-full ml-5 flex items-center"
                    id="bell-ic"
                  >
                    <input
                      className="w-full focus:outline-none"
                      type="search"
                      placeholder={t("search_here")}
                      id="bell-ic"
                      onChange={(event) => setEnterpriseSearch && setEnterpriseSearch(event.target.value)}
                      value={enterpriseSearch}
                    />
                  </div>
                </div>
              </div>
              <div
                className=" p-4"
                ref={listInnerRef}
              >
                <div className="grid grid-cols-12 mb-12 mt-3 gap-6 ">
                  {loading
                    ? [...Array(9)].map((_, index) => (
                      <EventsViewSkeleton />
                    ))
                    : eventsList && eventsList.length > 0 ? eventsList.map((item, index) => (
                      <EventCard item={item} />
                    )) : <div className='text-white col-span-12 text-center'>{t("no_events")}</div>}
                  {buffer && (
                    <div className="flex justify-center items-center w-full">
                      <VerticalBuffer />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {pagination.total_page > 1 &&
            <div className='mb-5 flex !justify-center items-center w-full'>
              <PaginationFooter pagination={pagination} active={active}
                handleChangePerPageRows={(perPageRow) =>
                  fetchEventList({ ...pagination, current_page: 1 }, eventsList, false)
                }
                handleChangePage={(page) =>
                  fetchEventList({ ...pagination, current_page: page }, eventsList, false)
                }
              />
            </div>}
          <CopyrightFooter />
        </>)}
    </div>
  );
};

export default EventsView;
